module.exports = __webpack_public_path__ + "static/media/img2.6fc25cb1.png";